import script from "./compGroupDetailIOCs.vue?vue&type=script&setup=true&lang=js"
export * from "./compGroupDetailIOCs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__